<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    titleExpanded: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isInitiallyOpen: {
      type: Boolean,
      default: false,
    },
    isNotCollapsible: {
      type: Boolean,
    },
    isOpenToggle: {
      type: Boolean,
      default: false,
    },
    showOnDesktop: {
      type: Boolean,
      default: false,
    },
    articleClass: {
      default: '',
      validator: function(value) {
        return typeof value === 'string' || Array.isArray(value)
      },
    },
    sheetClass: {
      default: '',
      validator: function(value) {
        return typeof value === 'string' || Array.isArray(value)
      },
    },
    isButton: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      isCardActive: false,
    }
  },
  computed: {
    label() {
      if (this.titleExpanded === '') {
        return this.title
      }
      return this.isCardActive ? this.titleExpanded : this.title
    },
    iconComputed() {
      if (this.showOnDesktop) {
        return this.isCardActive ? this.$style.iconActive : this.$style.icon
      } else {
        return this.isCardActive
          ? this.$style.iconActiveMobile
          : this.$style.iconMobile
      }
    },
    sheetComputed() {
      if (this.showOnDesktop) {
        return this.isCardActive ? this.$style.sheetActive : this.$style.sheet
      } else {
        return this.isCardActive
          ? this.$style.sheetActiveMobile
          : this.$style.sheetMobile
      }
    },
  },
  watch: {
    isOpenToggle: function(val) {
      this.isCardActive = !this.isCardActive
    },
  },
  created() {
    if (this.isNotCollapsible) {
      this.isCardActive = true
    } else {
      this.isCardActive = this.isInitiallyOpen
    }
  },
  methods: {
    toggleCard() {
      this.$emit('change', this.isCardActive)
      this.isCardActive = !this.isCardActive
    },
  },
}
</script>

<template>
  <article :class="[articleClass]">
    <v-btn
      v-if="isButton && !isNotCollapsible"
      :class="[showOnDesktop ? $style.headMobile : $style.head]"
      color="secondary"
      @click="toggleCard"
    >
      <v-icon :class="iconComputed">expand_more</v-icon> {{ label }}
    </v-btn>
    <h5
      v-else-if="!isNotCollapsible"
      :class="[showOnDesktop ? $style.headMobile : $style.head]"
      @click="toggleCard"
      ><v-icon :class="iconComputed">expand_more</v-icon> {{ label }}
    </h5>
    <v-sheet :class="[sheetClass, sheetComputed, $style.sheetStyle]">
      <v-skeleton-loader
        v-if="loading"
        type="image"
        height="100%"
        width="100%"
      />
      <slot />
    </v-sheet>
  </article>
</template>

<style lang="scss" module>
@import '@design';

.head {
  padding-bottom: 0;
  margin-top: 4px;
  margin-bottom: 4px;
  font-weight: light;
  font-weight: 100;
  cursor: pointer;
}

.headMobile {
  margin-bottom: 8px;
  font-weight: 100;
  text-align: center;
  cursor: pointer;
  border-bottom: 1px solid $color-gray-light;

  @media screen and (max-width: $screen-lg) {
    cursor: pointer;
    border-bottom: 1px solid $color-gray-light;
  }
}

.icon {
  margin-left: auto;
}

.iconMobile {
  margin-left: auto;

  @media screen and (min-width: $screen-lg) {
    display: none !important;
  }
}

.iconActive {
  composes: icon;
  transform: rotate(180deg);
}

.iconActiveMobile {
  composes: icon;
  transform: rotate(180deg);

  @media screen and (min-width: $screen-lg) {
    display: none !important;
  }
}

.sheetbase {
  padding: 0.5rem;
}

.sheetActive {
  composes: sheetbase;
  max-height: auto;
  overflow: hidden;
}

.sheet {
  composes: sheetbase;
  max-height: 0;
  padding: 0;
  overflow: hidden;
}

.sheetMobile {
  composes: sheetbase;
  max-height: initial;

  @media screen and (max-width: $screen-lg) {
    max-height: 0;
    padding: 0;
    overflow: hidden;
  }
}

.sheetActiveMobile {
  composes: sheetbase;

  @media screen and (max-width: $screen-lg) {
    max-height: auto;
    overflow: hidden;
  }
}
</style>
